<!-- Title & Button -->
<div class="card-section-header-wrapper">
  <h3 class="card-section-header">
    <span class="mr-4"><i class="{{ icon }}"></i> </span> {{ title }}
  </h3>
  <button *ngIf="showButton && buttonLabel" type="button" (click)="onButtonClick()" class="btn color_blue-btn btn-round" [disabled]="buttonDisabled">
    <i *ngIf="buttonIcon" class="{{ buttonIcon }}"></i>
    &nbsp;
    <strong>{{ buttonLabel }}</strong>
  </button>
</div>
